var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSignout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#DCEFE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0358 8.27614V5.70094H6.57856L9.08896 6.04294V11.5557L6.57496 11.8977H10.0358V9.43654H10.2758V12.1377H6.33496V5.46094H10.2758V8.27614H10.0358Z",
    fill: "#004C3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2756 7.80469V7.80709L10.2744 7.80589L10.2756 7.80469Z",
    fill: "#004C3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2744 9.90745L10.2756 9.90625V9.90865L10.2744 9.90745Z",
    fill: "#004C3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88477 5.01172H10.7268V7.09542L11.1303 6.71563L13.0844 8.7961L13.0198 8.85864L13.0832 8.91813L11.1291 10.9986L10.7256 10.6188V12.5885H5.88477V5.01172ZM12.8941 8.85648L11.1212 10.744L10.5456 10.2022V12.4085H6.06477V5.19172H10.5468V7.51202L11.1224 6.9702L12.8941 8.85648Z",
    fill: "#091E0E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37695 9.19716H11.2718L10.6142 9.89676L11.1098 10.3624L12.5246 8.85756L11.1098 7.35156L10.6142 7.81716L11.2718 8.51676H9.37695V9.19716Z",
    fill: "#004C3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignout);
export default __webpack_public_path__ + "static/media/IconSignout.c92661c7fbd232c2699af15bbca6899a.svg";
export { ForwardRef as ReactComponent };